export default "__VITE_ASSET__BiOS8s0H__"